type ReportableError = unknown;

declare global {
    interface Window {
        Sentry?: {
            captureException: (error: unknown, context?: Record<string, unknown>) => void;
        };
    }
}

/** Report an error to the console and optional Sentry integration. */
export const reportError = (error: ReportableError, context?: Record<string, unknown>) => {
    console.error(error, context);
    window.Sentry?.captureException(error, context);
};
